module.exports = __webpack_public_path__ + "static/media/goods3_1.8918e7fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/goods3_1.png
// module id = 1229
// module chunks = 0